import { createSlice } from "@reduxjs/toolkit";
import { login } from "../actions/userActions";
import { fetchCustomerByEmail } from "../actions/userActions";

const initialState = {
  customer: null,
  loading: false,
  error: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    updateCustomer: (state, action) => {
      if (state.customer && typeof action.payload === 'object') {
        state.customer = { ...state.customer, ...action.payload };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerByEmail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerByEmail.fulfilled, (state, action) => {
        state.loading = false;
        if (typeof action.payload === 'object' && action.payload) {
          // You can modify the customerNumber here if needed
          // For example: action.payload.customerNumber = `CUST-${action.payload.customerNumber}`;
          state.customer = { ...action.payload };
        } else {
          state.customer = null;
        }
      })
      .addCase(fetchCustomerByEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.error || "Failed to fetch customer";
      });
  },
});

export const selectCustomer = (state) => state.user.customer;
export const selectLoading = (state) => state.user.loading;
export const selectError = (state) => state.user.error;

export const { setLoading, setError, updateCustomer } = userSlice.actions;

export default userSlice.reducer;
